import { render } from "./GlobeVue.vue?vue&type=template&id=1c58fa71"
import script from "./GlobeVue.vue?vue&type=script&lang=js"
export * from "./GlobeVue.vue?vue&type=script&lang=js"

import "./GlobeVue.vue?vue&type=style&index=0&id=1c58fa71&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__